module.exports = __webpack_public_path__ + "static/media/maxParties_200_250.d03e936d.png";